

export class AlertStatusInput implements IAlertStatusInput {
    /** The auto-generated id of the alert master */
    alertId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IAlertStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertStatusInput {
    /** The auto-generated id of the alert master */
    alertId: number;
    /** The updated status */
    status: number;
}

